export default __webpack_public_path__ + "static/aniview-9fd5648ba92abd13edcddfd14f216b41.svg";